import Link from 'next/link'

import { pdfList } from '@/screens/Credit/page/data'

import cl from './ExtraQuestions.module.scss'

export const ExtraQuestions = () => {
	return (
		<div className={cl.extra}>
			<p className={cl.extra__text}>
				Ознакомьтесь с полными правила сервиса —{' '}
				<Link
					prefetch={false}
					href={pdfList[0].link}
					target="_blank"
					rel="noopener noreferrer"
					title="Перейти к документу"
					type={'file'}
					className={cl.extra__link}>
					в публичной оферте
				</Link>
			</p>
		</div>
	)
}
